module.exports = __webpack_public_path__ + "img/climber-game-avatar-manga.2ac9655b.png";